import { InfoWorkType, WorkType } from '@kanda-libs/ks-frontend-services';
import { useEnquiryContext } from 'pages/Enquiry/context';
import { useMemo } from 'react';
import { getEnquiryTotalFromItems } from 'utils';

export interface EnquiryQuoteCompleteHook {
  total: number;
  isLoading: boolean;
  infoWorkTypes: InfoWorkType[] | undefined;
  workType: WorkType | undefined;
}

export default function useEnquiryQuoteComplete(): EnquiryQuoteCompleteHook {
  const { enquiry, isLoading, infoWorkTypes, workType } = useEnquiryContext();

  const total = useMemo(() => {
    const jobItems = enquiry?.enquiry_info?.job_info?.job_items;
    if (!jobItems || jobItems.length === 0) return 0;
    return getEnquiryTotalFromItems(jobItems);
  }, [enquiry]);

  return {
    total,
    isLoading,
    infoWorkTypes,
    workType,
  };
}
